import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filterDeleted',
})
export class FilterDeletedPipe implements PipeTransform {
	// Segundo parametro está sendo usado no lbca-gridbox-unique para deleção logica (dá pra melhorar)
	transform(value: FilterItem[], enableLogicalDeletion: boolean, args?: any): any {
		if (enableLogicalDeletion) return value?.filter((i) => !i?.deleted);

		return value;
	}
}

interface FilterItem extends Record<string, unknown> {
	deleted?: boolean;
}
